import { ACHIEVEMENTS } from "../../shared/achievements";
import type { SavedLife } from "../storage";
import { formatAge, displayName } from "../../engine/text";

interface Props {
  saved: SavedLife | null;
  busy: boolean;
  error: string | null;
  onNewLife: () => void;
  onResume: () => void;
  dexCount: number;
  onDex: () => void;
  achievementCount: number;
  onAchievements: () => void;
  onStats: () => void;
}

export function Home({ saved, busy, error, onNewLife, onResume, dexCount, onDex, achievementCount, onAchievements, onStats }: Props) {
  return (
    <main className="screen center">
      <h1 className="title">Wild-lifepack</h1>
      <p className="lead muted">
        สุ่มเกิดเป็นสัตว์ 1 ชนิดจากทั่วโลก
        <br />
        แล้วเอาชีวิตรอดให้นานที่สุด มีลูกหลานให้มากที่สุด
      </p>
      <div className="actions">
        <button className="btn primary block" onClick={onNewLife} disabled={busy}>
          {busy ? "กำลังสุ่ม…" : "เกิดใหม่"}
        </button>
        {saved && (
          <button className="btn block" onClick={onResume} disabled={busy}>
            เล่นต่อ: {displayName(saved.life.species)} · อายุ {formatAge(saved.life.ageDays)}
          </button>
        )}
        <button className="btn block" onClick={onDex} disabled={busy}>
          สมุดสัตว์{dexCount > 0 ? ` · สะสมแล้ว ${dexCount.toLocaleString("th-TH")} ชนิด` : ""}
        </button>
        <button className="btn block" onClick={onAchievements} disabled={busy}>
          ความสำเร็จ · {achievementCount.toLocaleString("th-TH")}/{ACHIEVEMENTS.length.toLocaleString("th-TH")}
        </button>
        <button className="btn block" onClick={onStats} disabled={busy}>
          สถิติรวมของผู้เล่นทั้งหมด
        </button>
      </div>
      {error && <p className="error">{error}</p>}
      <p className="small">
        <a href="/animal">ดูรายชื่อสัตว์ในฐานข้อมูล</a>
      </p>
    </main>
  );
}
